import { render, staticRenderFns } from "./AFooterAddress.vue?vue&type=template&id=53b49c43&scoped=true&functional=true"
import script from "./AFooterAddress.vue?vue&type=script&lang=js"
export * from "./AFooterAddress.vue?vue&type=script&lang=js"
import style0 from "./AFooterAddress.vue?vue&type=style&index=0&id=53b49c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "53b49c43",
  null
  
)

export default component.exports